module.exports = __webpack_public_path__ + "img/04j-Shop_651.f00d4eed.jpg";